/**
 * Whether the API said nothing about a field.
 *
 * <p>The server is configured with `spring.jackson.default-property-inclusion: non_null`,
 * so a field that is null there is **left out of the JSON altogether** rather than sent
 * as null. It arrives here as `undefined`, and `value === null` is therefore false for
 * exactly the case it was written to catch.
 *
 * <p>That is a quiet failure in both directions. `data.accessDaysRemaining === null`
 * fell through to the other branch and put "undefined days of access left" on a
 * teacher's dashboard; `result.firstSequence !== null` was true for a missing field and
 * went on to call `.toLocaleString()` on it, which throws and takes the page with it.
 *
 * <p>`value == null` is the idiom that covers both, but it reads as a typo and invites
 * someone to "fix" it. Naming it says what is actually going on — the same reason
 * {@link sameId} exists one file over.
 */
export const absent = (value) => value === null || value === undefined;

/** The inverse, for the common `present(x) && …` guard before touching a value. */
export const present = (value) => !absent(value);
